module.exports = __webpack_public_path__ + "media/landing_page/iss1-8d3a5658.jpg";